var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_399",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29254",
    "data-name": "Group 29254",
    transform: "translate(212 10935)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -212, -10935)",
    filter: "url(#Ellipse_399)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_399-2",
    "data-name": "Ellipse 399",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons8-brave",
    transform: "translate(-194.567 -10920.567)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50170",
    "data-name": "Path 50170",
    d: "M20.3,12A11.3,11.3,0,1,0,31.6,23.3,11.3,11.3,0,0,0,20.3,12Z",
    transform: "translate(-1.233 -1.973)",
    fill: "#f57c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50171",
    "data-name": "Path 50171",
    d: "M26.882,34H12.965A3.976,3.976,0,0,0,9,37.965v3.569H31.224l-.377-2.583v-.985A3.976,3.976,0,0,0,26.882,34Z",
    transform: "translate(-1.233 -7.399)",
    fill: "#00695c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50172",
    "data-name": "Path 50172",
    d: "M28.56,41.753V43.26H27.054V41.753A.754.754,0,0,1,27.807,41h0A.754.754,0,0,1,28.56,41.753Zm-12.054,0V43.26H15V41.753A.754.754,0,0,1,15.753,41h0A.754.754,0,0,1,16.507,41.753Z",
    transform: "translate(-2.713 -9.126)",
    fill: "#004d40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50173",
    "data-name": "Path 50173",
    d: "M24.534,28.344V26.106a15.1,15.1,0,0,1-4.52,0v2.238A4.074,4.074,0,0,1,17,32.075a6.85,6.85,0,0,0,5.273,2.238,6.85,6.85,0,0,0,5.273-2.238A4.075,4.075,0,0,1,24.534,28.344Z",
    transform: "translate(-3.206 -5.452)",
    fill: "#ffe0b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50174",
    "data-name": "Path 50174",
    d: "M19.957,30.879c.753-.753,1.507-1.507,5.308-1.849a3.062,3.062,0,0,1-.035-.353V27.453a6.4,6.4,0,0,1-4.52,0v1.223a3.978,3.978,0,0,1-.886,2.331C19.867,30.965,19.908,30.927,19.957,30.879Z",
    transform: "translate(-3.903 -5.785)",
    fill: "#ffcc80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50175",
    "data-name": "Path 50175",
    d: "M9.26,35a2.26,2.26,0,1,0,2.26,2.26A2.26,2.26,0,0,0,9.26,35Z",
    transform: "translate(-0.74 -7.646)",
    fill: "#ff8f00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50176",
    "data-name": "Path 50176",
    d: "M8.143,26a4.143,4.143,0,1,0,4.143,4.143A4.143,4.143,0,0,0,8.143,26Z",
    transform: "translate(0 -5.426)",
    fill: "#ff8f00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50177",
    "data-name": "Path 50177",
    d: "M9.273,14a5.273,5.273,0,1,0,5.274,5.273A5.273,5.273,0,0,0,9.273,14Z",
    transform: "translate(0 -2.466)",
    fill: "#ff8f00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50178",
    "data-name": "Path 50178",
    d: "M13.52,6a4.52,4.52,0,1,0,4.52,4.52A4.52,4.52,0,0,0,13.52,6Z",
    transform: "translate(-1.233 -0.493)",
    fill: "#ff8f00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50179",
    "data-name": "Path 50179",
    d: "M22.52,4a4.52,4.52,0,1,0,4.52,4.52A4.52,4.52,0,0,0,22.52,4Z",
    transform: "translate(-3.453)",
    fill: "#ff8f00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50180",
    "data-name": "Path 50180",
    d: "M27.52,5a4.52,4.52,0,1,0,4.52,4.52A4.52,4.52,0,0,0,27.52,5Z",
    transform: "translate(-4.686 -0.247)",
    fill: "#ff8f00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50181",
    "data-name": "Path 50181",
    d: "M32.9,10a4.9,4.9,0,1,0,4.9,4.9A4.9,4.9,0,0,0,32.9,10Z",
    transform: "translate(-5.919 -1.48)",
    fill: "#ff8f00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50182",
    "data-name": "Path 50182",
    d: "M35.9,19a4.9,4.9,0,1,0,4.9,4.9A4.9,4.9,0,0,0,35.9,19Z",
    transform: "translate(-6.659 -3.7)",
    fill: "#ff8f00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50183",
    "data-name": "Path 50183",
    d: "M34.143,26a4.143,4.143,0,1,0,4.143,4.143A4.143,4.143,0,0,0,34.143,26Z",
    transform: "translate(-6.413 -5.426)",
    fill: "#ff8f00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50184",
    "data-name": "Path 50184",
    d: "M38.013,33a3.013,3.013,0,1,0,3.013,3.013A3.013,3.013,0,0,0,38.013,33Z",
    transform: "translate(-7.646 -7.153)",
    fill: "#ff8f00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50185",
    "data-name": "Path 50185",
    d: "M37.883,39a1.883,1.883,0,1,0,1.883,1.883A1.883,1.883,0,0,0,37.883,39Z",
    transform: "translate(-7.893 -8.633)",
    fill: "#ff8f00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50186",
    "data-name": "Path 50186",
    d: "M27.243,15.341A4.219,4.219,0,0,0,23.515,13H18.26A7.5,7.5,0,0,0,16,18.65a5.838,5.838,0,0,0,6.027,5.65,5.838,5.838,0,0,0,6.027-5.65A7.13,7.13,0,0,0,27.243,15.341Z",
    transform: "translate(-2.96 -2.22)",
    fill: "#ffe0b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50187",
    "data-name": "Path 50187",
    d: "M25.4,17a1.13,1.13,0,1,0,1.13,1.13A1.13,1.13,0,0,0,25.4,17ZM20.13,17a1.13,1.13,0,1,0,1.13,1.13A1.13,1.13,0,0,0,20.13,17Z",
    transform: "translate(-3.7 -3.206)",
    fill: "#00838f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50188",
    "data-name": "Path 50188",
    d: "M25.767,24H24.26C22,24,22,24.753,22,24.753s0,.753,1.507.753A2.787,2.787,0,0,0,25.767,24Z",
    transform: "translate(-4.44 -4.933)",
    fill: "#ff8a65"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrave);
export default __webpack_public_path__ + "static/media/brave.3830c0852be5639dbb3df2be46dbafdd.svg";
export { ForwardRef as ReactComponent };